import { I18n } from "i18n-js";
import { localeToHtmlLang } from "common/utils/locale";
import { ParentTranslations } from "common/i18n/parent";

const parentI18n = new I18n(ParentTranslations);
parentI18n.enableFallback = true;
parentI18n.defaultLocale = "ja_kanji";
parentI18n.locale = "ja_kanji";

export const setParentLocale = (locale?: string | null) => {
  const normalized =
    !locale || locale === "ja" ? "ja_kanji" : locale === "zh_cn" ? "zh_tw" : locale;
  if (normalized === "ja_kanji" || normalized === "en" || normalized === "zh_tw") {
    parentI18n.locale = normalized;

    // HTML lang属性を更新
    const rootElement = document.documentElement;
    rootElement.lang = localeToHtmlLang(normalized);

    // CSSクラスも更新（フォント切り替え用）
    rootElement.className = rootElement.className
      .replace(/\blang-[a-z]{2}(_[a-z]{2})?\b/g, "")
      .trim();
    if (normalized !== "ja_kanji") {
      rootElement.classList.add(`lang-${normalized}`);
    }
    return;
  }
  parentI18n.locale = "ja_kanji";
  document.documentElement.lang = "ja";
};

// 子どもの言語に戻す関数
export const restoreChildLocale = (childLocale: string) => {
  const rootElement = document.documentElement;

  // CSSクラスを復元
  rootElement.className = rootElement.className
    .replace(/\blang-[a-z]{2}(_[a-z]{2})?\b/g, "")
    .trim();
  if (childLocale && !childLocale.includes("ja")) {
    rootElement.classList.add(`lang-${childLocale}`);
  }

  // HTML lang属性を復元
  rootElement.lang = localeToHtmlLang(childLocale);
};

export default parentI18n;
